import { Blue, Yellow } from '../../styles/css';
import { copyCustomLayersAndSources } from '../layers';

export const defaultFillStyle = {
    'fill-color': Yellow,
    'fill-opacity': [
        'case',
        [
            'all',
            [
                '==',
                [
                    'feature-state',
                    'hover',
                ],
                true,
            ],
            [
                '==',
                [
                    'feature-state',
                    'active',
                ],
                true,
            ],
        ],
        0.4,
        [
            'boolean',
            [
                'feature-state',
                'hover',
            ],
            false,
        ],
        0.4,
        [
            'boolean',
            [
                'feature-state',
                'active',
            ],
            false,
        ],
        0.2,
        0.0,
    ],
};

export const defaultOutlineStyle = {
    'line-color': Blue,
    'line-width': [
        'case',
        [
            'boolean',
            [
                'feature-state',
                'hover',
            ],
            false,
        ],
        3.5,
        1.5,
    ],
};

export function combineCustomStyles( ctx, style ) {
    const stylesMerged = style;

    const customStyles = copyCustomLayersAndSources( ctx.map );

    stylesMerged.layers = [
        ...stylesMerged.layers,
        ...customStyles.layers,
    ];

    stylesMerged.sources = {
        ...stylesMerged.sources,
        ...customStyles.sources,
    };

    return stylesMerged;
}
